/**
 * The one module script `index.html` names (layered shell surfaces, WS-6 §3.8). It loads the
 * document-level stylesheet and runs the boot sequence against the real browser. It exports
 * nothing.
 */
// First: zod's jitless mode must be on before any module in the boot graph builds a zod schema,
// so the report-only CSP sees no `Function` call (D-1).
import '@zion/shell-system-surfaces/zod-jitless';
import './loader.css';
import { boot, browserEnvironment } from './boot.js';

void boot(browserEnvironment());
